<!-- <div class="container-fluid px-0">
    <div class="submenu submenu-inner border-bottom mb-3">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a [routerLink]="['/leads']" class="nav-link ms-0">CONTACTOS</a>
            </li>
            <li class="nav-item">
                <a routerLinkActive="active" [routerLink]="['/leads/dashboard']" class="nav-link active">DASHBOARD</a>
            </li>
        </ul>
    </div>
</div> -->
<div class="container">
  <h1>Dashboard Leads</h1>
  <div class="filters-expand-md">
    <div class="toggle-filters">
      <button type="button" class="btn btn-outline-secondary collapsed" data-bs-toggle="collapse"
        data-bs-target="#collapseFilters" aria-expanded="false" aria-controls="collapseFilters">Filtros <i
          class="fa fa-sliders" aria-hidden="true"></i></button>
    </div>
    <div id="collapseFilters" class="collapse">
      <!-- FILTERS -->
      <form [formGroup]="dataform">
        <div class="filters mb-3">
          <div class="filters-config-header">
            <div class="title mb-3">Filtros</div>
            <app-kpi-global-filters></app-kpi-global-filters>
          </div>
          <div class="cont__filters_fields row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
            <div class="col mb-3">
              <label class="form-label">Año</label>
              <select2 formControlName="Year" [value]="yearsDefaultValue" [data]="yearsData" [multiple]="false">
              </select2>
            </div>
            <div class="col mb-3">
              <label class="form-label">Mes</label>
              <select2 formControlName="Month" [value]="monthsDefaultValue" [data]="monthsData" [multiple]="false">
              </select2>
            </div>
            <!-- <div class="col mb-3">
              <label class="form-label">Tipología</label>
              <select2 formControlName="IdType" [value]="typesDefaultValue" [data]="typesData" [multiple]="false">
              </select2>
            </div>
            <div class="col mb-3">
              <label class="form-label">Interés</label>
              <select2 formControlName="IdSubtype" [value]="subtypesDefaultValue" [data]="subtypesData" [multiple]="false">
              </select2>
            </div> -->
            <div class="col mb-3">
              <label class="form-label">Marca</label>
              <select2 formControlName="IdBrand" [value]="brandsDefaultValue" [data]="brandsData" [multiple]="false">
              </select2>
            </div>

            <app-distributor-common-filter class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5"
              *ngIf="distributorFilters && userIsR2!==undefined" [hideDr]="true" [hideVnPlate]="true" [idBrand]="'0'"
              [filtersBreakLinePosition]="1" (modelFilterEmit)="getDistributorFilter($event)"
              (resetEmit)="getReset($event)" [showR2]="showR2"
              [inputFilter]="distributorFilters"></app-distributor-common-filter>
          </div>
          <div class="toggle-filters">
            <button class="btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilters"
              aria-expanded="false" aria-controls="collapseFilters"> <i class="fa fa-angle-up fa-2x"
                aria-hidden="true"></i></button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!--END Filters-->
</div>

<!-- DASHBOARD PV-->
<div [hidden]="!canViewTypePv">

  <div *ngIf="Dashboard.DashboardPV" class="container mb-4">
    <div class="cont__block_leads">
      <div class="cont__subtitle_leads">
        <!-- LEADS -->
        <h3 class="lateral__bar blue">Leads <span *ngIf="!userIsR2">R1</span></h3>
        <div [ngClass]="{'disabled': subtypesPvData && subtypesPvData.length==1}" class="header_select">
          <div class="label_select blue"><i class="fa fa-chevron-down" aria-hidden="true"></i> Interés</div>
          <select2 [(ngModel)]="subtypesPvDefaultValue" [data]="subtypesPvData" [multiple]="false" class="select_leads"
            (update)="filterData()">
          </select2>
        </div>
      </div>
      <div class="row highlights__dashboard gap-0 w-auto pv">
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title blue">Leads cerrados</div>
            <div class="card-body">{{Dashboard.DashboardPV.TotalClosedLeads | number:'1.0-0'}} <span
                class="porcentual">({{ (Dashboard.DashboardPV.TotalClosedLeadsPercent ||
                '0').replace('%','').split(',')[0] }} %)</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title blue">Media interacciones por leads</div>
            <div class="card-body">{{ +Dashboard.DashboardPV.MediaInteractionLeads.toString().replace(',', '.') | number }}</div>
          </div>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title blue">Tiempo medio de cierre</div>
            <div class="card-body cont-time">
              <!-- <div class="time">{{Dashboard.DashboardPV.MediaResponseTime | hoursLeads}}</div> -->
              <div class="time">{{ formatHM(Dashboard.DashboardPV.MediaResponseTime) }}</div>
              <div *ngIf="Dashboard.DashboardPV.MediaResponseTime.Days" class="days">
                ({{Dashboard.DashboardPV.MediaResponseTime.Days}} Días)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- LEADS -->
    <div *ngIf="Dashboard.DashboardPV.InternetLeadsTotal > 0" class="cont__block_leads">
      <div class="cont__subtitle_leads">
        <h3 class="lateral__bar info">Leads internet <span *ngIf="!userIsR2">R1</span></h3>
      </div>

      <div class="row highlights__dashboard gap-0 w-auto pv">

        <!-- CARD 1: Total -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <!-- EN TIEMPO (sobre total) -->
                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>

                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': internetOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ internetOnTimeTotal | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- EN RETRASO (sobre total) -->
                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': internetLeadsOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ internetLeadsOutTimeTotal | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetLeadsOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Total</div>
                <div>{{ Dashboard.DashboardPV.InternetLeadsTotal | number }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 2: Pendientes -->
        <div class="col-md-6 col-lg-4 mb-3" *ngIf="Dashboard.DashboardPV.InternetLeadsTotal > 0">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <!-- EN TIEMPO (pendientes: OnTime / (OnTime+OutTime)) -->
                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': internetPendingOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ Dashboard.DashboardPV.InternetLeadsOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetPendingOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- EN RETRASO (pendientes: OutTime / (OnTime+OutTime)) -->
                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': internetPendingOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ Dashboard.DashboardPV.InternetLeadsOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetPendingOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Pendientes</div>
                <div class="big-data">
                  <div>{{ (Dashboard.DashboardPV.InternetLeadsOnTime + Dashboard.DashboardPV.InternetLeadsOutTime) | number
                  }}</div>
                  <div class="porcentual">
                    ({{ (Dashboard.DashboardPV.InternetLeadsOnTime + Dashboard.DashboardPV.InternetLeadsOutTime)
                    / Dashboard.DashboardPV.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 3: Tratados -->
        <div class="col-md-6 col-lg-4 mb-3" *ngIf="Dashboard.DashboardPV.InternetLeadsTotal > 0">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <!-- EN TIEMPO (tratados) -->
                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': internetTreatedOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ Dashboard.DashboardPV.InternetLeadsTreatedOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetTreatedOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- EN RETRASO (tratados) -->
                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': internetTreatedOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ Dashboard.DashboardPV.InternetLeadsTreatedOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ internetTreatedOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Tratados</div>
                <div class="big-data">
                  <div>{{ (Dashboard.DashboardPV.InternetLeadsTreatedOnTime +
                  Dashboard.DashboardPV.InternetLeadsTreatedOutTime) | number }}</div>
                  <div class="porcentual">
                    ({{ (Dashboard.DashboardPV.InternetLeadsTreatedOnTime +
                    Dashboard.DashboardPV.InternetLeadsTreatedOutTime)
                    / Dashboard.DashboardPV.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- LEADS R2 LATE -->
    <div *ngIf="userIsR2 === false && distributorsR2Data" class="cont__block_leads">
      <div class="cont__subtitle_leads">
        <h3 class="lateral__bar info">Leads procedentes de R2</h3>
        <div class="header_select">
          <div class="label_select info">
            <i class="fa fa-chevron-down" aria-hidden="true"></i> Distribuidor
          </div>
          <select2 [(ngModel)]="distributorR2LateDefaultValue" [data]="distributorsR2Data" [multiple]="false"
            class="select_leads" (update)="onDistributorR2LateChange()">
          </select2>
        </div>
      </div>

      <div class="row highlights__dashboard gap-0 w-auto internet" *ngIf="DashboardR2Late">

        <!-- CARD 1: Total -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2LateOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ (DashboardR2Late.InternetLeadsOnTime + DashboardR2Late.InternetLeadsTreatedOnTime)
                          | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LateOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2LateOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ (DashboardR2Late.InternetLeadsOutTime + DashboardR2Late.InternetLeadsTreatedOutTime)
                          | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LateOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Total</div>
                <div>{{ DashboardR2Late.InternetLeadsTotal | number }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 2: Pendientes -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2LatePendingOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ DashboardR2Late.InternetLeadsOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LatePendingOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2LatePendingOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ DashboardR2Late.InternetLeadsOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LatePendingOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Pendientes</div>
                <div class="big-data">
                  <div>{{ (DashboardR2Late.InternetLeadsOnTime + DashboardR2Late.InternetLeadsOutTime) | number }}</div>
                  <div class="porcentual">
                    ({{ (DashboardR2Late.InternetLeadsOnTime + DashboardR2Late.InternetLeadsOutTime)
                    / DashboardR2Late.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 3: Tratados -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2LateTreatedOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ DashboardR2Late.InternetLeadsTreatedOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LateTreatedOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2LateTreatedOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ DashboardR2Late.InternetLeadsTreatedOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2LateTreatedOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Tratados</div>
                <div class="big-data">
                  <div>{{ (DashboardR2Late.InternetLeadsTreatedOnTime + DashboardR2Late.InternetLeadsTreatedOutTime) | number
                  }}</div>
                  <div class="porcentual">
                    ({{ (DashboardR2Late.InternetLeadsTreatedOnTime + DashboardR2Late.InternetLeadsTreatedOutTime)
                    / DashboardR2Late.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- LEADS R2 -->
    <div *ngIf="userIsR2 === false && distributorsR2Data" class="cont__block_leads">
      <div class="cont__subtitle_leads">
        <h3 class="lateral__bar info">Leads gestionados por R2</h3>
        <div class="header_select">
          <div class="label_select info">
            <i class="fa fa-chevron-down" aria-hidden="true"></i> Distribuidor
          </div>
          <select2 [(ngModel)]="distributorR2DefaultValue" [data]="distributorsR2Data" [multiple]="false"
            class="select_leads" (update)="onDistributorR2Change()">
          </select2>
        </div>
      </div>

      <div class="row highlights__dashboard gap-0 w-auto internet" *ngIf="DashboardR2">

        <!-- CARD 1: Total -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2OnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ (DashboardR2.InternetLeadsOnTime + DashboardR2.InternetLeadsTreatedOnTime)
                          | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2OnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2OutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ (DashboardR2.InternetLeadsOutTime + DashboardR2.InternetLeadsTreatedOutTime)
                          | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2OutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Total</div>
                <div>{{ DashboardR2.InternetLeadsTotal | number }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 2: Pendientes -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2PendingOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ DashboardR2.InternetLeadsOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2PendingOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2PendingOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ DashboardR2.InternetLeadsOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2PendingOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Pendientes</div>
                <div class="big-data">
                  <div>{{ (DashboardR2.InternetLeadsOnTime + DashboardR2.InternetLeadsOutTime) | number }}</div>
                  <div class="porcentual">
                    ({{ (DashboardR2.InternetLeadsOnTime + DashboardR2.InternetLeadsOutTime)
                    / DashboardR2.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CARD 3: Tratados -->
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-body miniDashDoard w-100">
              <div class="cont_minidata">

                <div class="minidata">
                  <label class="minilabel green">en tiempo</label>
                  <div class="gauge bg-gauge-green" [ngStyle]="{'--value': r2TreatedOnTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="green">
                          {{ DashboardR2.InternetLeadsTreatedOnTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2TreatedOnTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="minidata">
                  <label class="minilabel red">en retraso</label>
                  <div class="gauge bg-gauge-red" [ngStyle]="{'--value': r2TreatedOutTimePercent}">
                    <div class="gauge-inner">
                      <div class="data">
                        <div class="red">
                          {{ DashboardR2.InternetLeadsTreatedOutTime | number:'1.0-0' }}
                        </div>
                        <div class="porcentual">
                          ({{ r2TreatedOutTimePercent | number:'1.0-0' }}%)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="bigDashBoard">
                <div class="biglabel">Tratados</div>
                <div class="big-data">
                  <div>{{ (DashboardR2.InternetLeadsTreatedOnTime + DashboardR2.InternetLeadsTreatedOutTime) | number }}</div>
                  
                  <div class="porcentual">
                    ({{ (DashboardR2.InternetLeadsTreatedOnTime + DashboardR2.InternetLeadsTreatedOutTime)
                    / DashboardR2.InternetLeadsTotal * 100
                    | number:'1.0-0' }}%)
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>


  <div [hidden]="loading" class="container-fluid bg-grey mb-5">
    <div class="container">
      <div class="row flex-wrap">
        <div *ngIf="Dashboard.DashboardPV && canSeeTopTable" class="col-md-6 mb-3">
          <div class="bg-white h-100 p-3">
            <div class="w-100 mb-3">
              <h6 class="d-flex justify-content-center mt-tit-top"><strong>Top agentes</strong></h6>
            </div>
            <table class="table__top">
              <thead>
                <tr>
                  <th class="blue">Nombre</th>
                  <th class="blue text-center w-30">Leads creados</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let elem of Dashboard.DashboardPV.Agents">
                  <td>{{elem.Name}}</td>
                  <td class="text-center"><strong>{{elem.TotalLeads}}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="Dashboard.DashboardPV && canSeeTopTable" class="col-md-6 mb-3">
          <div class="bg-white h-100 p-3">
            <div class="w-100 mb-3">
              <h6 class="d-flex justify-content-center mt-tit-top"><strong>Top concesionarios</strong></h6>
            </div>
            <table class="table__top">
              <thead>
                <tr>
                  <th class="blue">Nombre</th>
                  <th class="blue text-center w-30">Leads cerrados</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let elem of Dashboard.DashboardPV.Distris">
                  <td>{{elem.Name}}</td>
                  <td class="text-center"><strong>{{elem.TotalLeads}}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--<div class="col-md-12">
          <div class="bg-white h-100 p-3">
            <div class="" id="chartTiempoRespuestaPv"></div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
<!-- END DASHBOARD PV-->


<!-- DASHBOARD RECLAMACION-->
<div [hidden]="!canViewTypeReclamacion">
  <div *ngIf="Dashboard.DashboardReclamacion" class="container mb-4">
    <div class="cont__subtitle_leads">
      <h3 class="lateral__bar red"> Leads Reclamaciones</h3>
      <div [ngClass]="{'disabled': subtypesRecData && subtypesRecData.length==1}" class="header_select">
        <label class="label_select red"><i class="fa fa-chevron-down" aria-hidden="true"></i> Interés</label>
        <select2 [(ngModel)]="subtypesRecDefaultValue" [data]="subtypesRecData" [multiple]="false" class="select_leads"
          (update)="filterData()">
        </select2>
      </div>
    </div>
    <div class="cont__highlights d-block">
      <div class="row highlights__dashboard gap-0 w-auto claims">
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title red">Leads cerrados</div>
            <div class="card-body">{{Dashboard.DashboardReclamacion.TotalClosedLeads | number:'1.0-0'}} <span class="porcentual">({{ (Dashboard.DashboardReclamacion.TotalClosedLeadsPercent || '0').replace('%','').split(',')[0] }} %)</span></div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title red">Media interacciones por leads</div>
            <div class="card-body">{{Dashboard.DashboardReclamacion.MediaInteractionLeads}}</div>
          </div>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <div class="card">
            <div class="card-title red">Tiempo medio de cierre</div>
            <div class="card-body cont-time">
              <!-- <div class="time">{{Dashboard.DashboardReclamacion.MediaResponseTime |
                hoursLeads}}</div> -->
              <div class="time">{{ formatHM(Dashboard.DashboardReclamacion.MediaResponseTime) }}</div>
              <div *ngIf="Dashboard.DashboardReclamacion.MediaResponseTime.Days" class="days">
                ({{Dashboard.DashboardReclamacion.MediaResponseTime.Days}} Días)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [hidden]="loading" class="container-fluid bg-grey mb-5">
    <div class="container">
      <div class="row flex-wrap">
        <div *ngIf="Dashboard.DashboardReclamacion && canSeeTopTable" class="col-md-6 mb-3">
          <div class="bg-white h-100 p-3">
            <div class="w-100 mb-3">
              <h6 class="d-flex justify-content-center mt-tit-top"><strong>Top agentes</strong></h6>
            </div>
            <table class="table__top">
              <thead>
                <tr>
                  <th class="red">Nombre</th>
                  <th class="red text-center w-30">Leads creados</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let elem of Dashboard.DashboardReclamacion.Agents">
                  <td>{{!elem.Name || elem.Name.trim() === '' ? 'Internet' : elem.Name}}</td>
                  <td class="text-center"><strong>{{elem.TotalLeads}}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="Dashboard.DashboardReclamacion && canSeeTopTable" class="col-md-6 mb-3">
          <div class="bg-white h-100 p-3">
            <div class="w-100 mb-3">
              <h6 class="d-flex justify-content-center mt-tit-top"><strong>Top concesionarios</strong></h6>
            </div>
            <table class="table__top">
              <thead>
                <tr>
                  <th class="red">Nombre</th>
                  <th class="red text-center w-30">Leads cerrados</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let elem of Dashboard.DashboardReclamacion.Distris">
                  <td>{{elem.Name}}</td>
                  <td class="text-center"><strong>{{elem.TotalLeads}}</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12">
          <div class="bg-white h-100 p-3">
            <div class="" id="chartTiempoRespuestaReclamacion"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Dashboard Reclamacion-->

<!-- DASHBOARD VN -->
<div [hidden]="!canViewTypeVn">
  <div class="container mb-4">
    <div class="cont__block_leads">
      <div class="cont__subtitle_leads">
        <h3 class="lateral__bar yellow">Leads VN</h3>
      </div>
      <div class="row highlights__dashboard gap-0 w-auto vn">
        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card">
            <div class="card-title yellow">Total enviados</div>
            <div class="card-body">{{ Dashboard?.DashboardVN?.TotalEnviados || 0 | number:'1.0-0' }}</div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card">
            <div class="card-title yellow">Solicitud Prueba Vehículo</div>
            <div class="card-body">{{ Dashboard?.DashboardVN?.SolicitudPrueba || 0 | number:'1.0-0' }} <span class="porcentual">({{ Dashboard?.DashboardVN?.SolicitudPruebaPercent || 0 }}%)</span></div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card">
            <div class="card-title yellow">Solicitud Oferta Vehículo VN</div>
            <div class="card-body">{{ Dashboard?.DashboardVN?.SolicitudOfertaVn || 0 | number:'1.0-0' }} <span class="porcentual">({{ Dashboard?.DashboardVN?.SolicitudOfertaVnPercent || 0 }}%)</span></div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 mb-3">
          <div class="card">
            <div class="card-title yellow">Solicitud Oferta Vehículo VO</div>
            <div class="card-body">{{ Dashboard?.DashboardVN?.SolicitudOfertaVo || 0 | number:'1.0-0' }} <span class="porcentual">({{ Dashboard?.DashboardVN?.SolicitudOfertaVoPercent || 0 }}%)</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Dashboard VN-->

<div *ngIf="loading">
  <!--Loader-->
  <div class="loader">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>


<!-- <section class="submenu">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link active" aria-current="page" [routerLink]="['/leads']">CONTACTOS</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" aria-current="page">dashboard</a>
    </li>
  </ul>
</section>

<div class="container">
    <div class="row">
      <form [formGroup]="dataform" class="bg-info py-4 px-5">
          <div class="row">
              <div class="col-lg-3 mb-4">
                  <select2 formControlName="Year" [value]="yearsDefaultValue" [data]="yearsData" [multiple]="false">
                  </select2>
              </div>
              <div class="col-lg-3 mb-4">
                  <select2 formControlName="Month" [value]="monthsDefaultValue" [data]="monthsData" [multiple]="false">
                  </select2>
              </div>
              <div class="col-lg-3 mb-4">
                  <select2 formControlName="AccountNumber" [value]="accountDefaultValue" [data]="accountNumbersData" [multiple]="false">
                  </select2>
              </div>
          </div>
      </form>
  </div>

</div>

<div class="row">
  <div class="col-12 pb-2 text-end">
      <a (click)="search()" class="btn btn-primary mb-2"><i class="fa fa-plus" aria-hidden="true"></i>
    FILTRAR</a>
      <a (click)="resetFilters()" class="btn btn-primary mb-2"><i class="fa fa-plus" aria-hidden="true"></i> BORRAR
    FILTROS</a>
  </div>

</div>

<div *ngIf="Dashboard.DashboardPV && permission == leadPermission.AdminOrCallCenter || permission == leadPermission.Pv" class="data__card col-md-12 mb-4">
  <div class="row">
      <div>
          LEADS PV
      </div>
  </div>
  <div class="row m-0">
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Leads Cerrados</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardPV.TotalClosedLeads}} ({{Dashboard.DashboardPV.TotalClosedLeadsPercent}})
              </div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Media Interacciones por leads</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardPV.MediaInteractionLeads}}</div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Tiempo Medio de Respuesta</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardPV.MediaResponseTime | hoursLeads}}
              </div>
          </div>
      </div>
  </div>
  <div class="row mt-5">
      <div class="col-md-4">
          <table>
              <tr>
                  <th>Nombre</th>
                  <th>Leads Cerrados</th>
              </tr>
              <tr *ngFor="let elem of Dashboard.DashboardPV.Agents">
                  <td>{{elem.Name}}</td>
                  <td>{{elem.TotalLeads}}</td>
              </tr>
          </table>
      </div>
      <div class="col-md-8">
          <div class="" id="chartTiempoRespuestaPv"> </div>
      </div>
  </div>
</div>

<div *ngIf="Dashboard.DashboardReclamacion && permission == leadPermission.AdminOrCallCenter || permission == leadPermission.Reclamacion" class="data__card col-md-12 mb-4">
  <div class="row">
      <div>
          LEADS RECLAMACIONES
      </div>
  </div>
  <div class="row m-0">
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Leads Cerrados</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardReclamacion.TotalClosedLeads}} ({{Dashboard.DashboardReclamacion.TotalClosedLeadsPercent}})
              </div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Media Interacciones por leads</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardReclamacion.MediaInteractionLeads}}
              </div>
          </div>
      </div>
      <div class="col-md-4">
          <div class="row">
              <div class="data-card-subtitle data-card-title-2rows col border px-3 py-1">Tiempo Medio de Respuesta</div>
          </div>
          <div class="row">
              <div class="data-card-data col p-3 bg-dark text-white"> {{Dashboard.DashboardReclamacion.MediaResponseTime | hoursLeads}}
              </div>
          </div>
      </div>
  </div>
  <div class="row mt-5">
      <div class="col-md-4">
          <table>
              <tr>
                  <th>Nombre</th>
                  <th>Leads Cerrados</th>
              </tr>
              <tr *ngFor="let elem of Dashboard.DashboardReclamacion.Agents">
                  <td>{{elem.Name}}</td>
                  <td>{{elem.TotalLeads}}</td>
              </tr>
          </table>
      </div>
      <div class="col-md-8">
          <div class="" id="chartTiempoRespuestaReclamacion"> </div>
      </div>
  </div>
</div>
-->